import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { S3_BUCKET_URL } from '@/constants';

import { OnboardingPage } from '../../../../components/Page';

export const ScreenStyles = styled(OnboardingPage)`
  padding-top: 24px;

  --background: linear-gradient(
    180deg,
    #14111e 9.33%,
    rgba(20, 17, 30, 0) 39.24%,
    #14111e 73.78%
  );

  ion-content {
    background: url('${S3_BUCKET_URL}/own-ai-roleplay-rooms/welcome/images.png')
      center/cover no-repeat;
  }
`;

export const MainImgStyles = styled.div`
  font-size: 0;
  line-height: 0;
  margin: 24px auto 0;

  img {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    object-fit: contain;
    max-height: 50vh;
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0;
  text-align: center;
  margin-bottom: 24px;
`;

export const SubtitleStyles = styled(UiTypography)`
  color: var(--text-color-neutral-white);
  margin-top: 12px;
  text-transform: none;
`;

export const ContentContainerStyles = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
`;
